import React, { useState } from "react";
import "./ServicesSection.css";
import { useTranslation } from "react-i18next";
import { getServices } from "./api";
import { useQuery } from "@tanstack/react-query";
import fallbackImg from "../../../../../assets/images/fallback.png";

function ServicesSection() {
  const { t, i18n } = useTranslation("home");

  const { data, isLoading } = useQuery({
    queryKey: ["services"],
    queryFn: getServices,
  });
  console.log(i18n.language.toLocaleLowerCase());
  if (isLoading) return <p>Loading...</p>;

  return (
    <section className="services-page-section">
      <div className="container services-section-container">
        {data?.map((item) => (
          <div className="services-card">
            <picture>
              <img src={item.image_url || fallbackImg} alt="" />
            </picture>
            <div className="services-card-content">
              <h6>{item.title?.[i18n.language.toLocaleLowerCase()]}</h6>
              <p className="small">
                {item.description?.[i18n.language.toLocaleLowerCase()]}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default ServicesSection;
